import { Route } from "react-router-dom";
import Protected from "../auth/Protected";
import AdminLayoutPage from "./layout";
import { UserRole } from "../../enums";
import ProfileRoute from "./profile/profile-router";
import UsersRoute from "./users/users-router";
import MembershipsPage from "./memberships";
import MembershipEditPage from "./memberships/MembershipEditPage";
import MembershipCreatePage from "./memberships/MembershipCreatePage";
import FeaturesPage from "./features";
import FeatureEditPage from "./features/FeatureEditPage";
import FeatureCreatePage from "./features/FeatureCreatePage";
import EmailTemplatesRoute from "./email-templates/email-templates-router";
import ServerSettingsRoute from "./server-settings/server-settings-router";
import TermsAndConditionsRoute from "./terms-and-conditions/terms-and-conditions-router";
import ContactUsRoute from "./contact-us/contact-us-router";
import AppFilesRoute from "./app-files/AppFilesRoute";
import ExerciseCategoriesRoute from "./exercise-category/ExerciseCategoriesRoute";
import ExerciseLoadTypeRoute from "./exercise-load-type/ExerciseLoadTypeRoute";
import ExercisesRoute from "./exercises/ExercisesRoute";
import AllergyCategoriesRoute from "./allergy-categories/allergy-categories-route";
import CharityIssueCategoriesRoute from "./charity-issue-categories/charity-issue-categories-route";
import CharitiesRoute from "./charities/charities-router";
import EventOccasionsRoute from "./event-occasions/event-occasions-router";
import DietaryPreferencesRoute from "./dietary-preferences/dietary-preferences-router";
import GreetingOccasionCategoriesRoute from "./greeting-occasion-categories/greeting-occasion-categories-router";
import GreetingOccasionsImagesRoute from "./greeting-occasions-images/greeting-occasions-images-router";
import PhysicalAndMentalSymptomsRoute from "./physical-and-mental-symptoms/physical-and-mental-symptoms-route";
import TemporaryIllnessesRoute from "./temporary-illnesses/temporary-illnesses-router";
import CharityEventTypesRoute from "./charity-event-types/charity-event-types-router";
import OccasionCollectionsRoute from "./occasion-collections/occasion-collections-router";
import GreetingMembershipsRoute from "./greeting-memberships/greeting-memberships-router";
import ShoppingCompaniesRoute from "./shopping-companies/shopping-companies-router";
export default (
  <Route
    path="/admin"
    element={
      <Protected path="/admin" roles={[UserRole.ADMIN, UserRole.SUPERADMIN]}>
        <AdminLayoutPage />
      </Protected>
    }
  >
      {ProfileRoute}
      {UsersRoute}
      {EmailTemplatesRoute}
      {ServerSettingsRoute}
      {TermsAndConditionsRoute}
      {ContactUsRoute}
      {AppFilesRoute}
      {ExerciseCategoriesRoute}
      {ExerciseLoadTypeRoute}
      {ExercisesRoute}
      {AllergyCategoriesRoute}
      {CharityIssueCategoriesRoute}
      {CharitiesRoute}
      {EventOccasionsRoute}
      {DietaryPreferencesRoute}
      {GreetingOccasionCategoriesRoute}
      {GreetingOccasionsImagesRoute}
      {PhysicalAndMentalSymptomsRoute}
      {TemporaryIllnessesRoute}
      {CharityEventTypesRoute}
      {OccasionCollectionsRoute}
      {GreetingMembershipsRoute}
      {ShoppingCompaniesRoute}
  </Route>
);
